import {
  PUBLIC_CONFIG_ELEMENT_ID,
  serializePublicConfig,
  type PublicConfig,
} from "@shared/deployment/public-config";

export function PublicConfigScript({ config }: { config: PublicConfig }) {
  return (
    <script
      id={PUBLIC_CONFIG_ELEMENT_ID}
      type="application/json"
      dangerouslySetInnerHTML={{ __html: serializePublicConfig(config) }}
    />
  );
}
